<template>
  <div class="product-research">
    <!-- 导航栏 -->
    <UnifiedNavBar />
    
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">关于我们合作</h1>
        <p class="page-subtitle">
          构建产业、学术、研发三位一体的创新生态，推动科技成果转化，助力企业技术升级与产业发展
        </p>
      </div>
    </div>

    <!-- 方案导航区 -->
    <div class="solutions-nav">
      <div class="container">
        <div class="nav-cards">
          <div class="nav-card" @click="scrollToSection('tech-manager')">
            <div class="nav-icon">👨‍💼</div>
            <h3>技术经理人</h3>
            <p>专业技术管理人才培养与服务平台</p>
          </div>
          <div class="nav-card" @click="scrollToSection('low-carbon')">
            <div class="nav-icon">🌱</div>
            <h3>低碳制造</h3>
            <p>绿色制造技术创新与智能化转型</p>
          </div>
          <div class="nav-card" @click="scrollToSection('home-care')">
            <div class="nav-icon">🏠</div>
            <h3>居家康养</h3>
            <p>智慧健康养老产业化解决方案</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术经理人解决方案 -->
    <div id="tech-manager" class="solution-section">
      <div class="container">
        <div class="solution-header">
          <h2 class="solution-title">技术经理人培养与服务</h2>
          <p class="solution-subtitle">
            培养具备技术背景和管理能力的复合型人才，为企业技术创新和产业升级提供专业支撑
          </p>
        </div>

        <!-- 方案概述 -->
        <div class="solution-overview">
          <div class="overview-image">
            <img src="https://trae-api-sg.mchost.guru/api/ide/v1/text_to_image?prompt=Professional%20technology%20manager%20leading%20innovation%20team%2C%20modern%20corporate%20office%2C%20digital%20transformation%2C%20strategic%20planning%2C%20business%20professional%20style&image_size=landscape_4_3" alt="技术经理人">
          </div>
          <div class="overview-content">
            <h3>构建技术管理人才生态</h3>
            <p>
              技术经理人是推动企业技术创新的核心力量，具备深厚的技术功底和卓越的管理能力。
              我们通过系统化培养体系，为企业输送能够驾驭技术发展趋势、领导创新团队、
              制定技术战略的高端复合型人才。
            </p>
            <div class="core-values">
              <div class="value-item">
                <span class="value-number">800+</span>
                <span class="value-label">培养人才</span>
              </div>
              <div class="value-item">
                <span class="value-number">96%</span>
                <span class="value-label">就业匹配率</span>
              </div>
              <div class="value-item">
                <span class="value-number">85%</span>
                <span class="value-label">管理岗晋升</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 核心培养体系 -->
        <div class="solution-products">
          <h3>核心培养体系</h3>
          <div class="products-grid">
            <div class="product-card">
              <div class="product-icon">🎯</div>
              <h4>技术战略管理</h4>
              <p>技术路线规划、创新战略制定、技术投资决策等战略管理能力培养</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🔬</div>
              <h4>技术创新实践</h4>
              <p>前沿技术跟踪、创新方法论、技术成果转化等实践能力训练</p>
            </div>
            <div class="product-card">
              <div class="product-icon">📈</div>
              <h4>商业化运营</h4>
              <p>技术商业化、市场分析、产品管理等商业运营技能培养</p>
            </div>
          </div>
        </div>

        <!-- 经典案例 -->
        <div class="solution-cases">
          <h3>培养成果案例</h3>
          <div class="cases-grid">
            <div class="case-card">
              <div class="case-header">
                <h4>制造业数字化转型</h4>
                <span class="case-industry">智能制造</span>
              </div>
              <p class="case-desc">
                为某大型制造企业培养技术经理人团队，成功推动企业数字化转型，
                建立智能制造体系，实现生产效率大幅提升。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">40%</span>
                  <span class="result-metric">效率提升</span>
                </div>
                <div class="result-item">
                  <span class="result-value">25%</span>
                  <span class="result-metric">成本降低</span>
                </div>
              </div>
            </div>
            <div class="case-card">
              <div class="case-header">
                <h4>科技企业创新管理</h4>
                <span class="case-industry">高新技术</span>
              </div>
              <p class="case-desc">
                为科技创新企业输送技术管理人才，建立完善的研发管理体系，
                加速技术成果产业化，推动企业快速发展。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">60%</span>
                  <span class="result-metric">研发效率</span>
                </div>
                <div class="result-item">
                  <span class="result-value">15项</span>
                  <span class="result-metric">专利申请</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 低碳制造解决方案 -->
    <div id="low-carbon" class="solution-section alt-bg">
      <div class="container">
        <div class="solution-header">
          <h2 class="solution-title">低碳制造技术创新</h2>
          <p class="solution-subtitle">
            构建绿色制造技术创新体系，推动制造业碳中和转型，实现经济发展与环境保护协调统一
          </p>
        </div>

        <!-- 方案概述 -->
        <div class="solution-overview">
          <div class="overview-content">
            <h3>引领绿色制造新时代</h3>
            <p>
              低碳制造是制造业可持续发展的必由之路。我们致力于推动清洁生产技术创新，
              通过数字化、智能化手段优化制造工艺，帮助企业构建绿色低碳的生产体系，
              在实现碳达峰碳中和目标的同时提升竞争优势。
            </p>
            <div class="core-values">
              <div class="value-item">
                <span class="value-number">45%</span>
                <span class="value-label">平均节能率</span>
              </div>
              <div class="value-item">
                <span class="value-number">65%</span>
                <span class="value-label">碳排放减少</span>
              </div>
              <div class="value-item">
                <span class="value-number">90%</span>
                <span class="value-label">绿色认证率</span>
              </div>
            </div>
          </div>
          <div class="overview-image">
            <img src="https://trae-api-sg.mchost.guru/api/ide/v1/text_to_image?prompt=Green%20manufacturing%20facility%20with%20renewable%20energy%2C%20smart%20production%20lines%2C%20carbon%20neutral%20technology%2C%20sustainable%20industrial%20design%2C%20eco-friendly%20atmosphere&image_size=landscape_4_3" alt="低碳制造">
          </div>
        </div>

        <!-- 核心技术体系 -->
        <div class="solution-products">
          <h3>核心技术体系</h3>
          <div class="products-grid">
            <div class="product-card">
              <div class="product-icon">⚡</div>
              <h4>清洁能源技术</h4>
              <p>太阳能、风能等可再生能源集成，能源管理系统优化，绿色电力供应</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🌿</div>
              <h4>碳足迹管理</h4>
              <p>碳排放监测、碳中和路径规划、碳资产管理等全生命周期碳管理</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🤖</div>
              <h4>智能节能系统</h4>
              <p>AI驱动的能耗优化、智能调度系统、设备能效提升等节能技术</p>
            </div>
          </div>
        </div>

        <!-- 产业化案例 -->
        <div class="solution-cases">
          <h3>绿色转型案例</h3>
          <div class="cases-grid">
            <div class="case-card">
              <div class="case-header">
                <h4>钢铁企业绿色改造</h4>
                <span class="case-industry">钢铁冶金</span>
              </div>
              <p class="case-desc">
                协助大型钢铁企业实施绿色制造改造，引入清洁生产技术，
                建设智能化节能系统，实现大幅度碳减排和能耗降低。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">55%</span>
                  <span class="result-metric">碳排放减少</span>
                </div>
                <div class="result-item">
                  <span class="result-value">35%</span>
                  <span class="result-metric">能耗降低</span>
                </div>
              </div>
            </div>
            <div class="case-card">
              <div class="case-header">
                <h4>化工园区低碳示范</h4>
                <span class="case-industry">化工行业</span>
              </div>
              <p class="case-desc">
                打造化工园区低碳制造示范基地，集成可再生能源、循环经济、
                智能制造等技术，建设绿色化工产业集群。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">70%</span>
                  <span class="result-metric">清洁能源占比</span>
                </div>
                <div class="result-item">
                  <span class="result-value">80%</span>
                  <span class="result-metric">废料回收率</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 居家康养解决方案 -->
    <div id="home-care" class="solution-section">
      <div class="container">
        <div class="solution-header">
          <h2 class="solution-title">居家康养智慧解决方案</h2>
          <p class="solution-subtitle">
            构建智慧健康养老产业生态，融合物联网、AI、大数据等技术，为老年人提供全生命周期康养服务
          </p>
        </div>

        <!-- 方案概述 -->
        <div class="solution-overview">
          <div class="overview-image">
            <img src="https://trae-api-sg.mchost.guru/api/ide/v1/text_to_image?prompt=Smart%20elderly%20care%20home%20with%20IoT%20health%20monitoring%20devices%2C%20AI%20assistant%2C%20comfortable%20modern%20living%20space%2C%20healthcare%20technology%2C%20warm%20atmosphere&image_size=landscape_4_3" alt="居家康养">
          </div>
          <div class="overview-content">
            <h3>重塑智慧康养新模式</h3>
            <p>
              面对人口老龄化挑战，我们致力于构建以居家为基础、社区为依托、
              机构为补充的智慧康养服务体系。通过关于我们深度融合，
              推动康养产业技术创新，为老年人提供精准化、个性化、智能化的康养服务。
            </p>
            <div class="core-values">
              <div class="value-item">
                <span class="value-number">24×7</span>
                <span class="value-label">智能守护</span>
              </div>
              <div class="value-item">
                <span class="value-number">98%</span>
                <span class="value-label">安全保障率</span>
              </div>
              <div class="value-item">
                <span class="value-number">96%</span>
                <span class="value-label">用户满意度</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 核心技术与产品 -->
        <div class="solution-products">
          <h3>核心技术与产品体系</h3>
          <div class="products-grid">
            <div class="product-card">
              <div class="product-icon">💓</div>
              <h4>智能健康监测</h4>
              <p>多维生理参数监测、慢病管理、健康风险预警等智能健康管理系统</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🏠</div>
              <h4>适老化智能家居</h4>
              <p>环境自适应调节、安全防护、紧急救助等适老化智能家居解决方案</p>
            </div>
            <div class="product-card">
              <div class="product-icon">👨‍⚕️</div>
              <h4>远程医疗平台</h4>
              <p>在线诊疗、健康咨询、康复指导等一体化远程医疗服务平台</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🤖</div>
              <h4>AI康养助手</h4>
              <p>智能陪伴、健康提醒、生活助理等人工智能康养服务机器人</p>
            </div>
          </div>
        </div>

        <!-- 产业化成果案例 -->
        <div class="solution-cases">
          <h3>产业化成果案例</h3>
          <div class="cases-grid">
            <div class="case-card">
              <div class="case-header">
                <h4>智慧康养示范社区</h4>
                <span class="case-industry">社区康养</span>
              </div>
              <p class="case-desc">
                与高校合作建设智慧康养示范社区，集成健康监测、安全防护、
                生活服务等功能，打造老年友好型智慧社区标杆项目。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">2000+</span>
                  <span class="result-metric">服务老人</span>
                </div>
                <div class="result-item">
                  <span class="result-value">92%</span>
                  <span class="result-metric">健康改善率</span>
                </div>
              </div>
            </div>
            <div class="case-card">
              <div class="case-header">
                <h4>康养产业园区建设</h4>
                <span class="case-industry">产业发展</span>
              </div>
              <p class="case-desc">
                参与康养产业园区规划建设，整合医疗、养老、科研等资源，
                构建关于我们一体化康养产业生态圈，推动康养产业集群发展。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">50+</span>
                  <span class="result-metric">入驻企业</span>
                </div>
                <div class="result-item">
                  <span class="result-value">20亿</span>
                  <span class="result-metric">产值规模</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 统计数据区域 -->
    <div class="stats-section">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-number">50+</div>
            <div class="stat-label">合作院校</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">200+</div>
            <div class="stat-label">技术项目</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">100+</div>
            <div class="stat-label">成果转化</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">95%</div>
            <div class="stat-label">客户满意度</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系咨询区域 -->
    <div class="contact-section">
      <div class="container">
        <div class="contact-content">
          <h2>开启关于我们合作之路</h2>
          <p>让我们携手推动科技创新，共创美好未来</p>
          <div class="contact-buttons">
            <button class="btn-primary">立即咨询</button>
            <button class="btn-secondary">了解更多</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import UnifiedNavBar from '@/components/UnifiedNavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'ProductResearch',
  components: {
    UnifiedNavBar,
    Footer
  },
  data() {
    return {
      activeSection: 'tech-manager'
    }
  },
  mounted() {
    // 监听滚动事件，更新活跃状态
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollToSection(sectionId) {
      this.activeSection = sectionId
      const element = document.getElementById(sectionId)
      if (element) {
        const headerOffset = 80 // 考虑导航栏高度
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    },
    handleScroll() {
      const sections = ['tech-manager', 'home-care', 'low-carbon']
      const scrollPosition = window.scrollY + 200 // 偏移量
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i])
        if (section && section.offsetTop <= scrollPosition) {
          this.activeSection = sections[i]
          break
        }
      }
    }
  }
}
</script>

<style scoped>
/* 页面头部样式 */
.page-header {
  background: linear-gradient(135deg, #0052cc 0%, #1e90ff 100%);
  color: white;
  padding: 120px 0 80px;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="%23ffffff" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>') repeat;
  opacity: 0.3;
}

.page-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
}

.page-subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  position: relative;
  z-index: 1;
}

/* 方案导航区域 */
.solutions-nav {
  padding: 80px 0;
  background: linear-gradient(to bottom, #f8fafc, #ffffff);
}

.nav-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2.5rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.nav-card {
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.nav-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.6s;
}

.nav-card:hover::before {
  left: 100%;
}

.nav-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  border-color: #0052cc;
}

.nav-card.active {
  border-color: #0052cc;
  background: linear-gradient(135deg, #0052cc 0%, #1e90ff 100%);
  color: white;
  transform: translateY(-5px);
}

.nav-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  display: block;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.nav-card h3 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 0.8rem;
}

.nav-card p {
  opacity: 0.85;
  line-height: 1.7;
  font-size: 1rem;
}

/* 统计数据区域 */
.stats-section {
  background: linear-gradient(135deg, #0052cc 0%, #1e90ff 100%);
  color: white;
  padding: 80px 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 3rem;
  text-align: center;
}

.stat-item {
  padding: 2rem;
}

.stat-number {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  display: block;
}

.stat-label {
  font-size: 1.1rem;
  opacity: 0.9;
}

/* 联系咨询区域 */
.contact-section {
  background: #f8fafc;
  padding: 100px 0;
  text-align: center;
}

.contact-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
}

.contact-content p {
  font-size: 1.2rem;
  color: #4a5568;
  margin-bottom: 3rem;
}

.contact-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary {
  background: linear-gradient(135deg, #0052cc 0%, #1e90ff 100%);
  color: white;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 82, 204, 0.4);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 82, 204, 0.6);
}

.btn-secondary {
  background: white;
  color: #0052cc;
  padding: 1rem 2.5rem;
  border: 2px solid #0052cc;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: #0052cc;
  color: white;
  transform: translateY(-2px);
}

/* 解决方案区域 */
.solution-section {
  padding: 100px 0;
  position: relative;
}

.solution-section:nth-child(even) {
  background: linear-gradient(to bottom, #f8fafc, #ffffff);
}

.solution-section.alt-bg {
  background: linear-gradient(to bottom, #f8fafc, #ffffff);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 方案头部 */
.solution-header {
  text-align: center;
  margin-bottom: 5rem;
}

.solution-title {
  font-size: 3rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1.5rem;
  position: relative;
}

.solution-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #0052cc, #1e90ff);
  border-radius: 2px;
}

.solution-subtitle {
  font-size: 1.3rem;
  color: #4a5568;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.7;
}

/* 方案概述 */
.solution-overview {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-bottom: 5rem;
}

.overview-image {
  position: relative;
}

.overview-image img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.overview-image:hover img {
  transform: scale(1.02);
}

.overview-content h3 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1.5rem;
}

.overview-content p {
  color: #4a5568;
  line-height: 1.8;
  margin-bottom: 2.5rem;
  font-size: 1.1rem;
}

.core-values {
  display: flex;
  gap: 2.5rem;
}

.value-item {
  text-align: center;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  flex: 1;
}

.value-number {
  display: block;
  font-size: 2.2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #0052cc, #1e90ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
}

.value-label {
  color: #4a5568;
  font-size: 0.95rem;
  font-weight: 500;
}

/* 产品组合 */
.solution-products {
  margin-bottom: 5rem;
}

.solution-products h3 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
}

.solution-products h3::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #2563eb);
  border-radius: 2px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2.5rem;
}

.product-card {
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
}

.product-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #2563eb);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.product-card:hover::before {
  transform: scaleX(1);
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.product-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.product-card h4 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 1rem;
}

.product-card p {
  color: #4a5568;
  line-height: 1.7;
  font-size: 0.95rem;
}

/* 经典案例 */
.solution-cases h3 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
}

.solution-cases h3::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #2563eb);
  border-radius: 2px;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 2.5rem;
}

.case-card {
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.case-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #2563eb);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.case-card:hover::before {
  transform: scaleX(1);
}

.case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.case-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.case-header h4 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a202c;
}

.case-industry {
  background: linear-gradient(135deg, #667eea, #2563eb);
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.case-desc {
  color: #4a5568;
  line-height: 1.7;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.case-results {
  display: flex;
  gap: 2.5rem;
  justify-content: center;
}

.result-item {
  text-align: center;
  padding: 1rem;
  background: #f7fafc;
  border-radius: 12px;
  flex: 1;
}

.result-value {
  display: block;
  font-size: 1.8rem;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea, #2563eb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
}

.result-metric {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .solution-overview {
    gap: 3rem;
  }
  
  .core-values {
    gap: 1.5rem;
  }
  
  .cases-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 80px 0 60px;
  }
  
  .page-title {
    font-size: 2.5rem;
  }
  
  .page-subtitle {
    font-size: 1.1rem;
  }
  
  .nav-cards {
    grid-template-columns: 1fr;
    padding: 0 1rem;
    gap: 2rem;
  }
  
  .nav-card {
    padding: 2rem;
  }
  
  .solution-section {
    padding: 60px 0;
  }
  
  .solution-title {
    font-size: 2.2rem;
  }
  
  .solution-overview {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
  
  .core-values {
    flex-direction: column;
    gap: 1rem;
  }
  
  .products-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .product-card {
    padding: 2rem;
  }
  
  .case-results {
    flex-direction: column;
    gap: 1rem;
  }
  
  .container {
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 2rem;
  }
  
  .solution-title {
    font-size: 1.8rem;
  }
  
  .nav-card {
    padding: 1.5rem;
  }
  
  .product-card {
    padding: 1.5rem;
  }
  
  .case-card {
    padding: 1.5rem;
  }
}
</style>

    <!-- 方案导航区 -->
    <section class="py-8 bg-gray-50">
      <div class="container mx-auto px-4">
        <div class="flex justify-center space-x-8">
          <button 
            @click="scrollToSection('technology-manager')"
            class="px-6 py-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 text-blue-600 font-semibold"
          >
            技术经理人
          </button>
          <button 
            @click="scrollToSection('low-carbon')"
            class="px-6 py-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 text-blue-600 font-semibold"
          >
            低碳制造
          </button>
          <button 
            @click="scrollToSection('home-care')"
            class="px-6 py-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 text-blue-600 font-semibold"
          >
            居家康养
          </button>
        </div>
      </div>
    </section>

    <!-- 技术经理人解决方案 -->
    <div id="tech-manager" class="solution-section">
      <div class="container">
        <div class="solution-header">
          <h2 class="solution-title">技术经理人培养与服务</h2>
          <p class="solution-subtitle">
            培养具备技术背景和管理能力的复合型人才，为企业技术创新和产业升级提供专业支撑
          </p>
        </div>

        <!-- 方案概述 -->
        <div class="solution-overview">
          <div class="overview-image">
            <img src="https://trae-api-sg.mchost.guru/api/ide/v1/text_to_image?prompt=Professional%20technology%20manager%20leading%20innovation%20team%2C%20modern%20corporate%20office%2C%20digital%20transformation%2C%20strategic%20planning%2C%20business%20professional%20style&image_size=landscape_4_3" alt="技术经理人">
          </div>
          <div class="overview-content">
            <h3>构建技术管理人才生态</h3>
            <p>
              技术经理人是推动企业技术创新的核心力量，具备深厚的技术功底和卓越的管理能力。
              我们通过系统化培养体系，为企业输送能够驾驭技术发展趋势、领导创新团队、
              制定技术战略的高端复合型人才。
            </p>
            <div class="core-values">
              <div class="value-item">
                <span class="value-number">800+</span>
                <span class="value-label">培养人才</span>
              </div>
              <div class="value-item">
                <span class="value-number">96%</span>
                <span class="value-label">就业匹配率</span>
              </div>
              <div class="value-item">
                <span class="value-number">85%</span>
                <span class="value-label">管理岗晋升</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 核心培养体系 -->
        <div class="solution-products">
          <h3>核心培养体系</h3>
          <div class="products-grid">
            <div class="product-card">
              <div class="product-icon">🎯</div>
              <h4>技术战略管理</h4>
              <p>技术路线规划、创新战略制定、技术投资决策等战略管理能力培养</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🔬</div>
              <h4>技术创新实践</h4>
              <p>前沿技术跟踪、创新方法论、技术成果转化等实践能力训练</p>
            </div>
            <div class="product-card">
              <div class="product-icon">📈</div>
              <h4>商业化运营</h4>
              <p>技术商业化、市场分析、产品管理等商业运营技能培养</p>
            </div>
          </div>
        </div>

        <!-- 经典案例 -->
        <div class="solution-cases">
          <h3>培养成果案例</h3>
          <div class="cases-grid">
            <div class="case-card">
              <div class="case-header">
                <h4>制造业数字化转型</h4>
                <span class="case-industry">智能制造</span>
              </div>
              <p class="case-desc">
                为某大型制造企业培养技术经理人团队，成功推动企业数字化转型，
                建立智能制造体系，实现生产效率大幅提升。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">40%</span>
                  <span class="result-metric">效率提升</span>
                </div>
                <div class="result-item">
                  <span class="result-value">25%</span>
                  <span class="result-metric">成本降低</span>
                </div>
              </div>
            </div>
            <div class="case-card">
              <div class="case-header">
                <h4>科技企业创新管理</h4>
                <span class="case-industry">高新技术</span>
              </div>
              <p class="case-desc">
                为科技创新企业输送技术管理人才，建立完善的研发管理体系，
                加速技术成果产业化，推动企业快速发展。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">60%</span>
                  <span class="result-metric">研发效率</span>
                </div>
                <div class="result-item">
                  <span class="result-value">15项</span>
                  <span class="result-metric">专利申请</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 居家康养解决方案 -->
    <div id="home-care" class="solution-section">
      <div class="container">
        <div class="solution-header">
          <h2 class="solution-title">居家康养智慧解决方案</h2>
          <p class="solution-subtitle">
            构建智慧健康养老产业生态，融合物联网、AI、大数据等技术，为老年人提供全生命周期康养服务
          </p>
        </div>

        <!-- 方案概述 -->
        <div class="solution-overview">
          <div class="overview-image">
            <img src="https://trae-api-sg.mchost.guru/api/ide/v1/text_to_image?prompt=Smart%20elderly%20care%20home%20with%20IoT%20health%20monitoring%20devices%2C%20AI%20assistant%2C%20comfortable%20modern%20living%20space%2C%20healthcare%20technology%2C%20warm%20atmosphere&image_size=landscape_4_3" alt="居家康养">
          </div>
          <div class="overview-content">
            <h3>重塑智慧康养新模式</h3>
            <p>
              面对人口老龄化挑战，我们致力于构建以居家为基础、社区为依托、
              机构为补充的智慧康养服务体系。通过关于我们深度融合，
              推动康养产业技术创新，为老年人提供精准化、个性化、智能化的康养服务。
            </p>
            <div class="core-values">
              <div class="value-item">
                <span class="value-number">24×7</span>
                <span class="value-label">智能守护</span>
              </div>
              <div class="value-item">
                <span class="value-number">98%</span>
                <span class="value-label">安全保障率</span>
              </div>
              <div class="value-item">
                <span class="value-number">96%</span>
                <span class="value-label">用户满意度</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 核心技术与产品 -->
        <div class="solution-products">
          <h3>核心技术与产品体系</h3>
          <div class="products-grid">
            <div class="product-card">
              <div class="product-icon">💓</div>
              <h4>智能健康监测</h4>
              <p>多维生理参数监测、慢病管理、健康风险预警等智能健康管理系统</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🏠</div>
              <h4>适老化智能家居</h4>
              <p>环境自适应调节、安全防护、紧急救助等适老化智能家居解决方案</p>
            </div>
            <div class="product-card">
              <div class="product-icon">👨‍⚕️</div>
              <h4>远程医疗平台</h4>
              <p>在线诊疗、健康咨询、康复指导等一体化远程医疗服务平台</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🤖</div>
              <h4>AI康养助手</h4>
              <p>智能陪伴、健康提醒、生活助理等人工智能康养服务机器人</p>
            </div>
          </div>
        </div>

        <!-- 产业化成果案例 -->
        <div class="solution-cases">
          <h3>产业化成果案例</h3>
          <div class="cases-grid">
            <div class="case-card">
              <div class="case-header">
                <h4>智慧康养示范社区</h4>
                <span class="case-industry">社区康养</span>
              </div>
              <p class="case-desc">
                与高校合作建设智慧康养示范社区，集成健康监测、安全防护、
                生活服务等功能，打造老年友好型智慧社区标杆项目。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">2000+</span>
                  <span class="result-metric">服务老人</span>
                </div>
                <div class="result-item">
                  <span class="result-value">92%</span>
                  <span class="result-metric">健康改善率</span>
                </div>
              </div>
            </div>
            <div class="case-card">
              <div class="case-header">
                <h4>康养产业园区建设</h4>
                <span class="case-industry">产业发展</span>
              </div>
              <p class="case-desc">
                参与康养产业园区规划建设，整合医疗、养老、科研等资源，
                构建关于我们一体化康养产业生态圈，推动康养产业集群发展。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">50+</span>
                  <span class="result-metric">入驻企业</span>
                </div>
                <div class="result-item">
                  <span class="result-value">20亿</span>
                  <span class="result-metric">产值规模</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 低碳制造解决方案 -->
    <div id="low-carbon" class="solution-section alt-bg">
      <div class="container">
        <div class="solution-header">
          <h2 class="solution-title">低碳制造技术创新</h2>
          <p class="solution-subtitle">
            构建绿色制造技术创新体系，推动制造业碳中和转型，实现经济发展与环境保护协调统一
          </p>
        </div>

        <!-- 方案概述 -->
        <div class="solution-overview">
          <div class="overview-content">
            <h3>引领绿色制造新时代</h3>
            <p>
              低碳制造是制造业可持续发展的必由之路。我们致力于推动清洁生产技术创新，
              通过数字化、智能化手段优化制造工艺，帮助企业构建绿色低碳的生产体系，
              在实现碳达峰碳中和目标的同时提升竞争优势。
            </p>
            <div class="core-values">
              <div class="value-item">
                <span class="value-number">45%</span>
                <span class="value-label">平均节能率</span>
              </div>
              <div class="value-item">
                <span class="value-number">65%</span>
                <span class="value-label">碳排放减少</span>
              </div>
              <div class="value-item">
                <span class="value-number">90%</span>
                <span class="value-label">绿色认证率</span>
              </div>
            </div>
          </div>
          <div class="overview-image">
            <img src="https://trae-api-sg.mchost.guru/api/ide/v1/text_to_image?prompt=Modern%20green%20manufacturing%20facility%20with%20renewable%20energy%2C%20solar%20panels%2C%20smart%20automation%2C%20sustainable%20production%20lines%2C%20environmental%20technology&image_size=landscape_4_3" alt="低碳制造">
          </div>
        </div>

        <!-- 核心技术与产品 -->
        <div class="solution-products">
          <h3>核心技术与解决方案</h3>
          <div class="products-grid">
            <div class="product-card">
              <div class="product-icon">🌱</div>
              <h4>清洁生产技术</h4>
              <p>工艺流程优化、清洁能源替代、污染物减排等清洁生产技术集成</p>
            </div>
            <div class="product-card">
              <div class="product-icon">♻️</div>
              <h4>循环经济体系</h4>
              <p>资源循环利用、废料再生处理、产业链协同等循环经济模式构建</p>
            </div>
            <div class="product-card">
              <div class="product-icon">📊</div>
              <h4>碳管理平台</h4>
              <p>碳足迹追踪、碳排放监测、碳资产管理等数字化碳管理系统</p>
            </div>
            <div class="product-card">
              <div class="product-icon">🤖</div>
              <h4>智能绿色制造</h4>
              <p>AI优化生产、智能能耗管理、预测性维护等智能化绿色制造技术</p>
            </div>
          </div>
        </div>

        <!-- 经典案例 -->
        <div class="solution-cases">
          <h3>绿色转型成功案例</h3>
          <div class="cases-grid">
            <div class="case-card">
              <div class="case-header">
                <h4>汽车制造绿色工厂</h4>
                <span class="case-industry">汽车制造</span>
              </div>
              <p class="case-desc">
                为某知名汽车制造企业打造零碳工厂，通过可再生能源应用、
                智能制造系统优化和循环经济模式，实现生产全流程绿色化。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">零碳</span>
                  <span class="result-metric">生产目标</span>
                </div>
                <div class="result-item">
                  <span class="result-value">30%</span>
                  <span class="result-metric">成本节约</span>
                </div>
              </div>
            </div>
            <div class="case-card">
              <div class="case-header">
                <h4>化工园区循环改造</h4>
                <span class="case-industry">石化行业</span>
              </div>
              <p class="case-desc">
                构建化工园区循环经济生态系统，实现企业间副产品循环利用，
                建立废热回收、废水处理循环等资源共享网络。
              </p>
              <div class="case-results">
                <div class="result-item">
                  <span class="result-value">85%</span>
                  <span class="result-metric">资源利用率</span>
                </div>
                <div class="result-item">
                  <span class="result-value">40%</span>
                  <span class="result-metric">排放减少</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>